import { useMemo } from 'react';
import { useColorScheme } from 'react-native';

import { useFeatureSettingStore } from '@/features/feature-management/store/featureSettingStore';
import { FeaturesEnum } from '@/features/feature-management/types/features';
import { useAppSettingStore } from '@/features/profile-setting/store/useAppSettingStore';
import { CombinedDarkTheme, CombinedDefaultTheme } from '@/styles/theme';
import { AppThemeMode } from '@/styles/type/appThemeMode';

export const useGetAppTheme = () => {
  const systemColorScheme = useColorScheme();
  const selectedTheme = useAppSettingStore((state) => state.selectedTheme);
  const updateIsDarkModeEnabled = useAppSettingStore(
    (state) => state.updateIsDarkModeEnabled
  );

  // Set theme based on stored app theme and system theme and dark-mode feature setting
  // access FeatureSettingStore directly due to FeatureProvider not being available here
  const localFeatures = useFeatureSettingStore((state) => state.features);
  const darkModeFeature = localFeatures.find(
    (f) => f.featureIdentifier === FeaturesEnum.DarkMode
  );
  const theme = useMemo(() => {
    const isDarkMode =
      darkModeFeature?.enabled === true &&
      (selectedTheme === AppThemeMode.DARK ||
        (selectedTheme === AppThemeMode.AUTO && systemColorScheme === 'dark'));
    updateIsDarkModeEnabled(isDarkMode);
    return isDarkMode ? CombinedDarkTheme : CombinedDefaultTheme;
  }, [
    darkModeFeature?.enabled,
    selectedTheme,
    systemColorScheme,
    updateIsDarkModeEnabled
  ]);

  return theme;
};
